import {
  useStatementTranslation,
  termIsValid,
} from '../useTranslation/useStatementTranslation';

/**
 * A custom hook that returns a function to translate a given term.
 * The returned function checks if a translation exists for the term.
 * If a translation exists, it returns the translated term.
 * If a translation does not exist, it returns `null`.
 *
 * For more details, see the related ADR: {@link ADRS/apps/web/hooks/useGlossaryTerms-001.md}.
 *
 * @returns {Function} A function that accepts a term as a string and returns the translated term or `null`.
 */
function useGlossaryTerms() {
  const t = useStatementTranslation();
  return (term: string) => {
    if (termIsValid(term)) {
      return t(term);
    }
    return null;
  };
}

export default useGlossaryTerms;
